






















import VueApexCharts from 'vue-apexcharts';
import Vue from 'vue';
import PageLoader from './PageLoader.vue';
import api from '../api';
import { CreditCardBrandCounts } from '../types/dashboard.types';

export default Vue.extend({
  methods: {
    changePeriod() {
      this.loadCreditCardBrandCounts();
    },
    loadCreditCardBrandCounts() {
      const params: any = {
        periodData: this.activityPeriod,
      };

      api.get('/dashboard/merchant/credit-card-brand-counts', { params }).then(({ data }) => {
        this.setSeries(data.data);
        (this.$refs.loader as any).setReady();
      }).catch(() => {
        (this.$refs.loader as any).setError();
      });
    },
    setSeries(data : CreditCardBrandCounts) {
      const others = this.dollarFormattedValueOrZero(data.total - (data.visa
       + data.americanExpress + data.mastercard + data.discover + data.ach));
      this.series = [
        this.dollarFormattedValueOrZero(data.visa),
        this.dollarFormattedValueOrZero(data.americanExpress),
        this.dollarFormattedValueOrZero(data.mastercard),
        this.dollarFormattedValueOrZero(data.discover),
        this.dollarFormattedValueOrZero(data.ach),
        others,
      ];
    },
    dollarFormattedValueOrZero(value:any) {
      const v:number = value ? value / 100 : 0;
      return v;
    },
  },
  mounted() {
    this.loadCreditCardBrandCounts();
  },
  data() {
    return {
      activityPeriod: 'thisMonth',
      series: [] as number[],
      chartOptions: {
        chart: {
          width: 380,
          type: 'pie',
        },
        labels: ['Visa', 'American Express', 'MasterCard', 'Discover', 'ACH', 'Other'],
        colors: ['#162170', '#eb151a', '#f68221', '#800080', '#6cc4ee', '#c7af67'],
        tooltip: {
          y: {
            formatter(val:number) {
              return `$${val.toLocaleString()}`;
            },
            title: {
              formatter(seriesName:string) {
                return `${seriesName}: `;
              },
            },
          },
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        }],
      },
    };
  },
  computed: {
    activityPeriods() {
      return [
        { value: 'thisMonth', display: 'Month To Date' },
        { value: 'lastMonth', display: 'Previous Month' },
        { value: 'thisYear', display: 'Year To Date' },
      ];
    },
  },
  components: { apexchart: VueApexCharts, PageLoader },
});
